import { createSearchParams, useSearchParams } from 'react-router-dom';
export const useSearchParamsCopy = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    return [createSearchParams(searchParams), setSearchParams];
};
